import AboutUs1Container from "../../../components/pages/other/aboutUs1";

const AboutUs1 = () => {
  return <AboutUs1Container />;
};

export default AboutUs1;
